(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["force-collection-availability"] && !Shopify.designMode) return;
  try {
    const PARAM = 'filter.v.availability';
  const COLLECTION_PATH =
    /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/(?!(?:vendors|types)\/?$)([^/]+)(?:\/(?!products(?:\/|$))[^/]+)?\/?$/i;

  const getHandle = (pathname) => {
    const match = pathname.match(COLLECTION_PATH);
    return match ? decodeURIComponent(match[1]).toLowerCase() : null;
  };

  const currentHandle = getHandle(window.location.pathname);

  const apply = (link) => {
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.searchParams.has(PARAM)) return;

    const handle = getHandle(url.pathname);
    // Links to the current collection (pagination, sorting, breadcrumbs) must keep the user's filter choice
    if (!handle || handle === currentHandle) return;

    url.searchParams.set(PARAM, '1');
    link.setAttribute('href', url.pathname + url.search + url.hash);
  };

  const applyWithin = (root) => {
    if (root.matches('a[href*="/collections/"]')) apply(root);
    root.querySelectorAll('a[href*="/collections/"]').forEach(apply);
  };

  const init = () => {
    applyWithin(document.body);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) applyWithin(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };
  
  init();
  } catch(e) { console.error(e); }
})();

})();
